// src/context/MeetingsContext.js
// Stores scheduled PrrepX Meet events in Firestore so all employees can see them.

import React, { createContext, useContext, useEffect, useState } from "react";
import {
  collection, addDoc, doc, updateDoc, onSnapshot, orderBy, query, serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

const MeetingsContext = createContext({ meetings: [], addMeeting: () => {}, updateMeeting: () => {} });

export const MeetingsProvider = ({ children }) => {
  const [meetings, setMeetings] = useState([]);

  // Real-time listener on the shared scheduledMeetings collection
  useEffect(() => {
    const q = query(collection(db, "scheduledMeetings"), orderBy("startISO", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setMeetings(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return unsub;
  }, []);

  const addMeeting = async ({ title, room, startISO, endISO, description, scheduledBy, scheduledByUid, guests }) => {
    try {
      await addDoc(collection(db, "scheduledMeetings"), {
        title,
        room,
        startISO,
        endISO,
        description: description || "",
        scheduledBy: scheduledBy || "",
        scheduledByUid: scheduledByUid || "",
        guests: guests || [],
        createdAt: serverTimestamp(),
      });
    } catch (err) {
      console.error("MeetingsContext: could not save meeting", err);
    }
  };

  const updateMeeting = async (meetingId, updates) => {
    try {
      await updateDoc(doc(db, "scheduledMeetings", meetingId), updates);
    } catch (err) {
      console.error("MeetingsContext: could not update meeting", err);
      throw err;
    }
  };

  return (
    <MeetingsContext.Provider value={{ meetings, addMeeting, updateMeeting }}>
      {children}
    </MeetingsContext.Provider>
  );
};

export const useMeetings = () => useContext(MeetingsContext);
